import {
    ISymbolStateConfig,
    ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TweenLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {TombOfAkhenatenReelController} from "../reel/TombOfAkhenatenReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";

export interface ITombOfAkhenatenSymbolStates extends ISymbolStates {
    noWin: ISymbolStateConfig;
    semiDimmed: ISymbolStateConfig;
    respinShine: ISymbolStateConfig;
    respinLock: ISymbolStateConfig;
}

export class TombOfAkhenatenReelSymbol extends StateReelSymbol {
    //protected _symMask: PIXI.Graphics | null;
    //protected _background: PIXI.Sprite | null;
    //protected _frameMid: PIXI.Sprite | null;
    //protected _frameTop: PIXI.Sprite | null;
    //protected _frameBottom: PIXI.Sprite | null;
    //protected _symImage: PIXI.Sprite | null;
    /*public static LOW_SYM_MAP: Map<string, string> = new Map([
        ['L1', 'A'],
        ['L2', 'K'],
        ['L3', 'Q'],
        ['L4', 'J'],
        ['L5', '10'],
    ]);*/

    private static getSpriteName(symName: string, assetName: string): string {
        let spriteName: string = "";

        switch (assetName) {
            case "background":
                spriteName = "_bg";
                break;
            case "midFrame":
                spriteName = "_frameMid";
                break;
            case "topFrame":
                spriteName = "_frameTop";
                break;
            case "bottomFrame":
                spriteName = "_frameBottom";
                break;
            case "symImage":
                spriteName = "_symImage";
                break;
        }
        return symName + spriteName;
    }

    private static getBottomFramePosition(rowCount: number): number {
        let bottomFramePosY: number = 0;

        switch (rowCount) {
            case 4:
                bottomFramePosY = -49;
                break;
            case 5:
                bottomFramePosY = -79;
                break;
        }

        return bottomFramePosY;
    }

    /*public onRemove(): void {
        //delete this._symMask;
        //delete this._background;
        //delete this._frameMid;
        //delete this._frameTop;
        //delete this._frameBottom;
        //delete this._symImage;

        //this._symMask = null;
        //this._background = null;
        //this._frameMid = null;
        //this._frameTop = null;
        //this._frameBottom = null;
        //this._symImage = null;
        super.onRemove();
    }*/

    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();

        let background: PIXI.Sprite,
            symImage: PIXI.Sprite;

        if(this.symName === "W2") {
            let customPath: string = this.symName + "/" + this.symName,
                currentSprite: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(customPath)[0]);

            currentSprite.anchor.set(0.5);
            currentSprite.position.set(0, 0);
            currentSprite.scale.set(1);
            currentSprite.visible = false;
            currentSprite.name = this.symName;
            symImage = currentSprite;
            this.addChild(symImage);
            this.pivot.y = 38;
            return;
        }else{
            background = this.getSprite(this.symName, "background");
            symImage = this.getSprite(this.symName, "symImage");
        }
        //do not change below sequence
        if (TombOfAkhenatenGameConfig.instance.OVERLAPPING_SYMBOLS.indexOf(this.symName) > -1) {
            let frameMid: PIXI.Sprite = this.getSprite(this.symName, "midFrame"),
                frameTop = this.getSprite(this.symName, "topFrame"),
                frameBottom = this.getSprite(this.symName, "bottomFrame");

            frameBottom.position.set(0, TombOfAkhenatenReelSymbol.getBottomFramePosition(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN));

            let symMaskHeight: number = (TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT / TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN) + ((TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT) / 2);

             let symMask: PIXI.Graphics = new PIXI.Graphics();
            symMask.name = "_symMask";
            symMask.beginFill(0xFFFFFF, 1);
            symMask.drawRect(this.position.x - 5, this.position.y, TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH + 10, symMaskHeight);
            symMask.endFill();
            symMask.position.set(-(TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH / 2), -((TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT / 2) + ((TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT) / 2)));
            symMask.height = symMaskHeight;

            background.mask = symMask;
            frameMid.mask = symMask;
            symImage.mask = symMask;
            this.addChild(symMask, background, frameTop, symImage, frameMid, frameBottom);
        } else {
            this.addChild(background, symImage);
        }
    }

    protected addNewStateAnimation(timeline: TimelineLite, newState: SymbolStateTransition, stateAnimation: TimelineSprite, delay: number): void {
        const symName: string = this.symName;
        if (symName == "W2" && (newState.state.keyword === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.win.keyword)) {
            timeline.add(new SpineTween((stateAnimation as any), 0, "Wild_toggle", 0), delay);
            timeline.add(TweenLite.to(stateAnimation, 0.001, {alpha: 1}), delay)
            return;
        }

        if (newState.state.keyword === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.idle?.keyword) {
            if (TombOfAkhenatenGameConfig.instance.SYMBOLS_WITH_WIN_SPINE.indexOf(symName) != -1) {
                timeline.add(new SpineTween((stateAnimation as any), 0, symName.toLowerCase() + "_idle_animation", 0), delay);
                timeline.add(TweenLite.to(stateAnimation, 0.001, {alpha: 1}), delay);
            }
            return;
        }

        if (newState.state.keyword === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.win.keyword) {
            //have to return in case of wild because in TOAWildSymbols called super.addNewStateAnimation //need to ask why?
            if (symName == "W") {
                return;
            }
            if (TombOfAkhenatenGameConfig.instance.SYMBOLS_WITH_WIN_SPINE.indexOf(symName) != -1) {
                timeline.add(new SpineTween((stateAnimation as any), 0, symName.toLowerCase() + "_win_animation", 0), delay);
                timeline.add(TweenLite.to(stateAnimation, 0.001, {alpha: 1}), delay)
            }
            return;
        }

        if (newState.state.keyword === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.noWin.keyword) {//No win state moved to reelSymbol to fix #150;
            if (stateAnimation) {
                if(symName == "W"){
                    const reelController = Reels.getReel(this.reelId);
                    const sprite = (<TombOfAkhenatenReelController>reelController)._x2OnWild;
                    if(sprite){
                        sprite.tint = 0x555555;
                    }
                }
                (<PIXI.Sprite[]>this.children).forEach((sprite: PIXI.Sprite) => {
                    if(sprite.name == "W2"){
                        (sprite as PIXI.Sprite).tint = 0x555555;
                    }
                    if (sprite.name && sprite.visible) {
                        if ((sprite.name.indexOf("_symImage") > -1) || (sprite.name.indexOf("_bg") > -1)) {
                            (sprite as PIXI.Sprite).tint = 0x555555;
                        }
                        if (TombOfAkhenatenGameConfig.instance.OVERLAPPING_SYMBOLS.indexOf(symName) > -1) {
                            if ((sprite.name.indexOf("_frameTop") > -1) ||
                                (sprite.name.indexOf("_frameBottom") > -1) ||
                                (sprite.name?.indexOf("_frameMid") > -1) ||
                                (sprite.name.indexOf("_propImg") > -1) ||
                                (sprite.name.indexOf("_gemsImg") > -1) ||
                                (sprite.name.indexOf("_textImg") > -1)) {
                                (sprite as PIXI.Sprite).tint = 0x555555;
                            }
                        }
                    }
                });
            }
            return;
        }
        if (newState.state.keyword === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.semiDimmed.keyword) {//No win state moved to reelSymbol to fix #150;
            if (stateAnimation) {
                (<PIXI.Sprite[]>this.children).forEach((sprite: PIXI.Sprite) => {
                    if(sprite.name == "W2"){
                        (sprite as PIXI.Sprite).tint = 0xadadad;
                    }
                    if (sprite.name && sprite.visible) {
                        if ((sprite.name?.indexOf("_symImage") > -1)) {
                            (sprite as PIXI.Sprite).tint = 0xadadad;
                        }
                    }
                    if (TombOfAkhenatenGameConfig.instance.OVERLAPPING_SYMBOLS.indexOf(this.symName) > -1) {
                        if ((sprite.name?.indexOf("_frameTop") > -1) ||
                            (sprite.name?.indexOf("_frameBottom") > -1) ||
                            (sprite.name?.indexOf("_frameMid") > -1) ||
                            (sprite.name?.indexOf("_gemsImg") > -1) ||
                            (sprite.name?.indexOf("_textImg") > -1)) {
                            (sprite as PIXI.Sprite).tint = 0xadadad;
                        }
                    }
                });
            }
            return;
        }

        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if (newState.state.keyword === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.normal.keyword) {
            (<PIXI.Sprite[]>this.children).forEach((sprite: PIXI.Sprite) => {
                if (sprite.name) {
                    sprite.visible = true;
                    sprite.tint = 0xffffff;
                }
            });
        }
    }

    private getSprite(symName: string, assetName: string,visible:boolean=false): PIXI.Sprite {
        let customPath: string = symName + "/layers/" + (assetName === "symImage" ? symName : assetName),
            currentSprite: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(customPath)[0]);

        currentSprite.anchor.set(0.5);
        currentSprite.visible = visible;
        currentSprite.name = TombOfAkhenatenReelSymbol.getSpriteName(symName, assetName);

        return currentSprite;
    }

    public changeTextureForAS(symName:string,activeRow:number):void{
        let background: PIXI.Sprite,
            symImage: PIXI.Sprite;
        const getMaskYPos = (): number =>{
            let y:number=-((TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT / 2) + ((TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT) / 2));
            if(activeRow===5){
                y=-203;
            }else if(activeRow===4){
                y=-205;
            }else if(activeRow===3){
                y=-173;
            }
            return y;
        }
        if(symName === "W2") {
            let customPath: string = symName + "/" + symName,
                currentSprite: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(customPath)[0]);

            currentSprite.anchor.set(0.5);
            currentSprite.position.set(0, 0);
            currentSprite.scale.set(1);
            currentSprite.visible = true;
            currentSprite.name = symName;
            symImage = currentSprite;
            this.addChild(symImage);
            this.pivot.y = 38;
            return;
        }else{
            background = this.getSprite(symName, "background",true);
            symImage = this.getSprite(symName, "symImage",true);
        }
        //do not change below sequence
        if (TombOfAkhenatenGameConfig.instance.OVERLAPPING_SYMBOLS.indexOf(symName) > -1) {
            let frameMid: PIXI.Sprite = this.getSprite(symName, "midFrame",true),
                frameTop:PIXI.Sprite = this.getSprite(symName, "topFrame",true),
                frameBottom:PIXI.Sprite = this.getSprite(symName, "bottomFrame",true);

            frameBottom.position.set(0, TombOfAkhenatenReelSymbol.getBottomFramePosition(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN));
            if(activeRow===3 && symName==="S"){
                frameBottom.position.y=-23;
            }
            let symMaskHeight: number = (TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT / TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN) + ((TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT) / 2);

            let symMask: PIXI.Graphics = new PIXI.Graphics();
            symMask.name = "_symMask";
            symMask.beginFill(0xFFFFFF, 1);
            symMask.drawRect(this.position.x - 5, this.position.y, TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH + 10, symMaskHeight);
            symMask.endFill();
            symMask.position.set(-(TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH / 2), getMaskYPos());
            symMask.height = symMaskHeight;

            background.mask = symMask;
            frameMid.mask = symMask;
            symImage.mask = symMask;
            this.addChild(symMask, background, frameTop, symImage, frameMid, frameBottom);
        } else {
            this.addChild(background, symImage);
        }

    }

}
